import { observable, action } from 'mobx';
import agent from '../services/web/agent';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import passwordMatchValidator from '../services/validations/passwordMatchValidator';
import erorrHandler from '../services/web/erorrHandler';
import ConfigurationsStore from './configurationsStore';

class ResetPasswordStore {

    @observable resetPasswordProgress;

    @observable errors = null;
    @observable isError = null;
    @observable resetPasswordErrorMessage = null;

    @observable userNameValidationMessage;
    @observable tenantValidationMessage;
    @observable passwordValidationMessage;

    @observable values = {
        userName: '',
        tenant: '',
        password: '',
        eulaAccepted: false
    };

    formErrors = [];

    @action setUserName(userName) {
        this.values.userName = userName.trim();
    }

    @action setTenant(tenant) {
        this.values.tenant = tenant;
    }

    @action setPassword(password) {
        this.values.password = password;
    }

    @action setEula(eulaAccepted) {
        this.values.eulaAccepted = eulaAccepted;
    }

    @action setToken(token) {
        this.values.token = token;
    }

    @action reset() {
        this.values.userName = '';
        this.values.tenant = '';
        this.values.password = '';
        this.values.eulaAccepted = false;
        this.token = '';
    }

    validateUserName() {

        const validation = userSharedFormsValidator.validateUserName(this.values.userName);

        this.userNameValidationMessage = validation.errors.first('userName');

        this.formErrors.push(validation.errorCount);
    }

    validateTenant() {

        const validation = userSharedFormsValidator.validateGenericRequiredField(this.values.tenant);

        this.tenantValidationMessage = validation.errors.first('field');

        this.formErrors.push(validation.errorCount);
    }

    validatePassword() {

        const result = passwordMatchValidator.validatePassword(this.values.password);

        this.passwordValidationMessage = result.passwordValidationMessage;

        this.formErrors.push(result.validation.errorCount);
    }

    @action validateForm() {

        this.formErrors = [];
        this.validateUserName();
        ConfigurationsStore.isMultitenancyMode && this.validateTenant();
        this.validatePassword();

        return this.formErrors.filter((valid) => valid > 0).length <= 0;
    }


    @action resetPassword() {

        this.resetPasswordProgress = true;
        this.errors = undefined;

        return agent.Users.resetPassword(this.values.userName, this.values.tenant, this.values.password, this.values.token)
                    .catch(action((err) => {

                        this.resetPasswordErrorMessage = erorrHandler.getErrorMessage(err);

                        throw err;
                    }))
                    .finally(action(() => this.resetPasswordProgress = false));
    }

}

export default new ResetPasswordStore();



// WEBPACK FOOTER //
// ./src/stores/resetPasswordStore.js